import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
  base: {
    color: 'black',
    fontWeight: 600,
    lineHeight: '23px',
    marginTop: '0px',
    marginBottom: '8px',
  },
  variants: {
    variant: {
      main: {
        fontSize: '24px',
        letterSpacing: '0.24px',
      },
      sub: {
        fontSize: '15px',
        letterSpacing: '0.15px',
        textTransform: 'uppercase',
      },
      item: {
        fontWeight: 400,
        color: 'grey.dark.2',
        fontSize: '18px',
        lineHeight: '22px',
        letterSpacing: '0.18px',
      },
      project: {
        color: 'grey.dark.2',
        fontWeight: 500,
        fontSize: '18px',
        letterSpacing: '0.18px',
        lineHeight: '16px',
        marginBottom: '0px',
      },
      formSection: {
        fontSize: '18px',
        lineHeight: '20px',
        letterSpacing: '0.18px',
        fontWeight: 400,
        paddingBottom: '7px',
        display: 'inline-block',
        borderBottom: '2px solid {colors.halton.blue}',
        marginBottom: '19px',
        userSelect: 'none',
      },
      subsub: {},
      basic1: {
        marginTop: '10px',
        fontSize: '24px',
        letterSpacing: '0.24px',
        marginBottom: '20px',
      },
      basic2: {
        fontSize: '20px',
        lineHeight: '20px',
        letterSpacing: '0.18px',
        fontWeight: 400,

        textDecoration: 'underline',
        textDecorationColor: 'halton.blue',
        textDecorationThickness: '2px',
        textUnderlinePosition: 'under',
        textUnderlineOffset: '6px',
        margin: '12px 0px 26px',
      },
      basic3: {
        fontSize: '16px',
        letterSpacing: '0.15px',
        textTransform: 'uppercase',
      },
      basic4: {
        fontWeight: 600,
        color: 'grey.dark.2',
        fontSize: '16px',
        lineHeight: '22px',
        letterSpacing: '0.18px',
      },
      basic5: {},
    },
    markdown: {
      true: {
        marginTop: '10px',
      },
    },
  },
  defaultVariants: {
    variant: 'main',
    markdown: false,
  },
  compoundVariants: [
    {
      variant: 'basic1',
      markdown: true,
      css: {
        marginTop: '12px',
      },
    },
    {
      variant: 'basic2',
      markdown: true,
      css: {
        marginTop: '11px',
      },
    },
  ],
});
